import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import OfferCardData from "../Data/OfferCardData.json";
const OfferPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <!-- Breadcrumbs --> */}
      <section className="breadcrumbs offer-page-bread">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="offer-page-bread-content">
                <h1 className="offer-page-cont-title">Promotion/ Offers</h1>
                <p>
                  Volutpat tincidunt viverra viverra hac viverra enim, gravida
                  ac nunc. In congue dignissim faucibus eu, eu ac. Aliquet nam
                  tempor est tortor. Eu volutpat nibh platea diam semper neque.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Breadcrumbs --> */}

      <section className="offer-page-area">
        <div className="container">
          <div className="row">
            {OfferCardData.map((SingleOfferCard) => (
              <div
                className="col-lg-4 col-md-6 col-12"
                key={SingleOfferCard.id}
              >
                <div className={SingleOfferCard.singleclass}>
                  <div className="offer-single-head">
                    <img src={SingleOfferCard.img} alt="#" />
                    <div className={SingleOfferCard.offerinfoclass}>
                      <div className="offer-s-info-wrapper">
                        <span className="offer-info-icon">
                          <i className="fi-rr-time-fast"></i>
                        </span>
                        <p className="pffer-info-text">
                          {SingleOfferCard.hours}
                        </p>
                      </div>
                      <div className="offer-s-info-wrapper">
                        <span className="offer-info-icon">
                          <i className="fi-rr-book-alt"></i>
                        </span>
                        <p className="pffer-info-text">
                          {SingleOfferCard.class}
                        </p>
                      </div>
                      <div className="offer-s-info-wrapper">
                        <span className="offer-info-icon">
                          <i className="fi-rr-dollar"></i>
                        </span>
                        <p className="pffer-info-text">
                          {SingleOfferCard.course}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="offer-single-wrapper-content">
                    <span className="deadline-btn">
                      {SingleOfferCard.deadline}
                    </span>
                    <h3 className="offer-single-wrap-cont-title">
                      <Link to="#">{SingleOfferCard.title}</Link>
                    </h3>
                    <div className="offer-single-wrapper-cont-btn">
                      <div className={SingleOfferCard.singlebtn}>
                        <Link to="/offerdetails" class="theme-btn">
                          <i className="fi-rr-user-add"></i>
                          Enroll now
                        </Link>
                        <Link
                          to="/offerdetails"
                          className="theme-btn course-info-btn"
                        >
                          Course info
                        </Link>
                      </div>
                      <Link
                        to="/offerdetails2"
                        className={SingleOfferCard.singlebtn2}
                      >
                        More details
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OfferPage;
